// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2z6cp","fs":"Modal_fs__3Tw7Y","docked":"Modal_docked__3-trG"};